import { AppName } from 'types'

export const signInRoute = '/sign-in'
export const HUBSPOT_IDS: Partial<Record<AppName, string>> = {
  ratings: '2ff6b301-ca40-4669-9fa9-44712129d33f',
  analytics: '7fd964d7-41f1-4fd2-88ae-c0a469ee0c9f',
  box: '2ff17a77-660e-442f-9d51-42aeceed1c00',
  'country-profiles': '9349a482-602f-4bbd-97fd-32b65db3bab9',
  'methodology-profiles': '6913aa4f-d096-4e39-861e-786a2d73f76f',
  'pre-issuance': '218b9d3e-b4e1-4b78-a220-865f765b928d',
}
